import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import CustomHref from "../CustomHref";
import ModalAlert from "../../basic/ModalAlert";

const AdPlanError = ({ errors, clearError }) => {
  const { t } = useTranslation(["advertising"]);
  if (!errors?.adPlanError) {
    return null;
  }
  const isNoSubscription = errors.adPlanError === "No subscription";
  const isLimitReached =
    errors.adPlanError === "Media plan limit reached" || errors.adPlanError === "Marketplace limit reached";
  return (
    <ModalAlert
      title={isNoSubscription ? t(($) => $.advertising.adPlanError["You don't have a plan, yet."]) : errors.adPlanError}
      onClick={() => clearError("adPlanError")}
      msg={
        <>
          {isNoSubscription ?
            <>
              {t(($) => $.advertising.adPlanError["Choose your plan type on the billing page."])}{" "}
              <Link to="/user/billing" onClick={() => clearError("adPlanError")}>
                <CustomHref textDecoration="none" text={t(($) => $.advertising.adPlanError["Pick Now"])} />
              </Link>
              .
            </>
          : isLimitReached ?
            <>
              {t(
                ($) =>
                  $.advertising.adPlanError["Upgrade your plan type on the billing page to create more media plans."],
              )}{" "}
              <Link to="/user/billing" onClick={() => clearError("adPlanError")}>
                <CustomHref textDecoration="none" text={t(($) => $.advertising.adPlanError["Upgrade Now"])} />
              </Link>
              .
            </>
          : <>
              {t(($) => $.advertising.adPlanError["Upgrade your plan type on the billing page."])}{" "}
              <Link to="/user/billing" onClick={() => clearError("adPlanError")}>
                <CustomHref textDecoration="none" text={t(($) => $.advertising.adPlanError["Pick Now"])} />
              </Link>
              .
            </>
          }
        </>
      }
    />
  );
};

export default AdPlanError;
